import React, { useEffect, useState } from 'react';
import ProductDetailTabTypeModel from './models/ProductDetailTabTypeModel';
import ProductDetailTabTypeDetailsFields from './ProductDetailTabTypeDetailsFields';

function AddProductDetailTabType({ sendDataToParent, onLoad }) {
  const [formData, setFormData] = useState(new ProductDetailTabTypeModel());

  useEffect(() => {
    const initial = new ProductDetailTabTypeModel();
    if (onLoad) onLoad(initial);
    if (sendDataToParent) sendDataToParent(initial);
  }, []);

  const handleData = (data) => {
    setFormData(data);
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <ProductDetailTabTypeDetailsFields formData={formData} sendDataToParent={handleData} />
    </div>
  );
}

export default AddProductDetailTabType;
